// Fire-and-forget CTA click tracking. Never blocks navigation or throws.
// Only fires when the visitor has accepted analytics (GDPR consent).
import { hasAnalyticsConsent } from "@/lib/consent";

export const trackClick = (event) => {
  if (!hasAnalyticsConsent()) return;
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
};
